import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f23cac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paggination" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-arrow-left-thin wide-hover" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "paggination__link is-dots"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-arrow-right wide-hover" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
          class: "paggination__link is-arrow-paggination",
          style: {"cursor":"pointer"}
        }, _hoisted_3)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
        return (_openBlock(), _createElementBlock("li", { key: page }, [
          (typeof page === 'number')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: ($event: any) => (_ctx.goToPage(page)),
                class: _normalizeClass(['paggination__link', { 'is-selected': page === _ctx.currentPage }]),
                style: {"cursor":"pointer"}
              }, _toDisplayString(page), 11, _hoisted_4))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(page), 1))
        ]))
      }), 128)),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
          class: "paggination__link is-arrow-paggination",
          style: {"cursor":"pointer"}
        }, _hoisted_7)
      ])
    ])
  ]))
}